module.exports = __webpack_public_path__ + "media/07stilt walking.38b5f2a0.mp3";